import React from "react";
import User1 from "../../../../Assets/Images/Groupadm.png";
import User2 from "../../../../Assets/Images/Groupadmj.png";
import User3 from "../../../../Assets/Images/Groupadms.png";

const AuditionMarkDistribution = ({ instruction, roundInfo }) => {
  return (
    <>
      {/* Page no 568  */}

      {/* <Round1com/> */}

      <div className="m-3">
        <div className="row ">
          <div className="card bg-dark">
            <h4 className="col-md-12 text-warning pt-2 pb-2 RowAmd">
              Audition Mark Distribution
            </h4>
            <hr />

            <div className="row">
              <div className="d-flex justify-content-between mb-3">
                <div className="col-md-1 ImgNb">
                  <img
                    src={User1}
                    alt=""
                    className="img-fluid ps-3 ImgB pt-2"
                  />
                </div>
                <div className="col-md-6">
                  <div className="card BGadm pt-1 px-3">
                    <h4 className="text-light py-2 UserMark">User Vote Mark</h4>
                  </div>
                </div>
                <div className="col-md-3">
                  <input
                    type="text"
                    className=" pt-3 pb-3 px-3 card BGadm2"
                    // placeholder="30"
                    value={roundInfo?.user_vote_mark}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-between mb-3">
                <div className="col-md-1 ImgNb">
                  <img
                    src={User2}
                    alt=""
                    className="img-fluid ps-3 ImgB pt-2"
                  />
                </div>
                <div className="col-md-6">
                  <div className="card BGadm pt-1 px-3">
                    <h4 className="text-light py-2 UserMark">
                      Jury Or Judge Mark{" "}
                    </h4>
                  </div>
                </div>
                <div className="col-md-3">
                  <input
                    type="text"
                    className=" pt-3 pb-3 px-3 card BGadm2"
                    // placeholder="30"
                    value={roundInfo?.jury_or_judge_mark}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AuditionMarkDistribution;
